<router-outlet></router-outlet>
<div kendoDialogContainer></div>
